export default __webpack_public_path__ + "static/media/img-37-aelfdene.c4f6271a.jpg";